$(document).on("submit", ".form-builder-form", function(e) {
    e.preventDefault();

    let $form = $(this);
    let formData = new FormData(this);
    let $button = $form.find("button[type=submit]");
    let originalText = $button.html();

    $('.form-success').remove();
    $('.form-errors').remove();
    $form.find('.form-field').removeClass('form-field-has-error');
    $button.prop("disabled", true).html("Submitting...");

    $.ajax({
        url: $form.attr("action"),
        type: $form.attr("method") || "POST",
        data: formData,
        processData: false,
        contentType: false,
        cache: false,
        success: function(response) {
            console.log('success', response);
            if (response.status === "success") {
                $form.find('.btnrow').before('<div class="form-success"><p>' + response.message + '</p></div>');
                $form[0].reset();
            } else if (response.status === "redirect") {
                window.location.href = response.redirect;
            }
        },
        error: function (xhr, status, error) {
            //console.log(xhr, status, error);
            let $errorMessage;
            if (xhr.status === 422) {
                $errorMessage = $('<div class="form-errors"><p>Please fix the following errors before submitting:</p><ul></ul></div>');
                let $errors = xhr.responseJSON.errors;

                $.each($errors, function (field, messages) {
                    let $input = $form.find("[name='" + field + "']");

                    if ($input.length) {
                        $input.parent().addClass('form-field-has-error');
                    }

                    $.each(messages, function (i, msg) {
                        $errorMessage.find("ul").append("<li>" + msg + "</li>");
                    });
                });
            } else {
                $errorMessage ='<div class="form-errors"><p style="padding: 0;">Sorry, there was an error and the message could not be sent</p></div>';
            }

            $form.find('.btnrow').before($errorMessage);
        },
        complete: function () {
            $button.prop("disabled", false).html(originalText);
        }
    });
});
